module.exports = __webpack_public_path__ + "img/mizao.ce091709.jpg";